import { render, staticRenderFns } from "./TimberStatistics.vue?vue&type=template&id=767e0d84&scoped=true"
import script from "./TimberStatistics.vue?vue&type=script&lang=js"
export * from "./TimberStatistics.vue?vue&type=script&lang=js"
import style0 from "./TimberStatistics.vue?vue&type=style&index=0&id=767e0d84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767e0d84",
  null
  
)

export default component.exports